var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue-point"},[_c('div',{staticClass:"line top-line",class:{erase: _vm.fisrt}}),_c('div',{staticClass:"point"}),_c('div',{staticClass:"line",class:{erase: _vm.last}})])}
var staticRenderFns = []

export { render, staticRenderFns }